import AIPromptSettings from './AIPromptSettings';

export default AIPromptSettings;
